import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import SericeByIdContainer from "../../Componant/organisms/ServiceById";
import { useServiceRequest } from "../../hooks/useServiceRequest";

function SericeById() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const { request } = useServiceRequest();
  const service = request.find((service) => service.id === serviceId);

  if (!serviceId || service === undefined)
    return (
      <Row>
        <Col className="d-flex justify-content-center">User Id Not Found</Col>
      </Row>
    );
  return (
    <div className="page-body">
      <SericeByIdContainer service={service} />
    </div>
  );
}

export default SericeById;
